module.exports = __webpack_public_path__ + "public/Icons/youtube.png?19e59167";